
import request from '@/plugins/request';
import axios from '@/plugins/axios';

export function orderInfo(params) {
  return request({
    url: 'orderInfo/createOrderInfo',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  });
}

// 获取充值历史
export function getRechargeHistory(params) {
	return request({
		url: '/api/recharge/history',
		method: 'get',
    params,
  
	})
}
export function getRechargeHistory2(params) {
	return request({
		url: '/api/recharge/history2',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory3(params) {
	return request({
		url: '/api/recharge/history3',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory4(params) {
	return request({
		url: '/api/recharge/history4',
		method: 'get',
    data: params,
  
	})
}


export function getRechargeHistory5(params) {
	return request({
		url: '/api/recharge/history5',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory6(params) {
	return request({
		url: '/api/recharge/history6',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory7(params) {
	return request({
		url: '/api/recharge/history7',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory8(params) {
	return request({
		url: '/api/recharge/history8',
		method: 'get',
    data: params,
  
	})
}


export function getRechargeHistory9(params) {
	return request({
		url: '/api/recharge/history9',
		method: 'get',
    data: params,
  
	})
}


export function getRechargeHistory10(params) {
	return request({
		url: '/api/recharge/history10',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory11(params) {
	return request({
		url: '/api/recharge/history11',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory12(params) {
	return request({
		url: '/api/recharge/history12',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory13(params) {
	return request({
		url: '/api/recharge/history13',
		method: 'get',
    data: params,
  
	})
}

export function getRechargeHistory14(params) {
	return request({
		url: '/api/recharge/history14',
		method: 'get',
    data: params,
  
	})
}
// 创建充值订单
export function createOrder(data) {
  return request({
    url:'/api/orders',
    method: 'post',
    data
  })
}
export function addRechargeRecord(data) {
  return request({
    url: '/orders',
    method: 'post',
    data
  })
}

// 更新订单
export function updateOrder(order_id, updates) {
  return request({
    url: `/api/orders/${order_id}`,
    method: 'put',
    data: updates
  })
}

// 删除订单接口
export function deleteOrder(order_id, params) {
  return request({
    url: `/api/orders/${order_id}`,
    method: 'delete',
    params
  })
}
